jQuery(document).ready(function($) {
  /* LOCAL HELPER FUNCTIONS */
  /**
   * Reference: https://davidwalsh.name/query-string-javascript
   * @param  {string} name
   * @return {string} paratmeters in url
   */
  function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');

    let regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    let results = regex.exec(location.search);

    return (results === null) ?
      '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  };

  /**
   * Look for the corresponding JSON object from the given slug
   * @param  {string} slug
   * @param  {object} collection
   * @return {object} the desired object
   */
  function slugToObj(slug, collection) {
    return _.find(collection, function(obj) {
      return obj.slug === slug;
    });
  }

  /* FOUNDATION */
  $(document).foundation();

  /* PROGRAMME FINDER */
  if ($('.programme-finder').length) {
    Vue.component('multiselect', VueMultiselect.Multiselect);
    new Vue({
      el: '#programme-finder',
      data: {
        isLoading: true,
        elevelsList: phpVars.elevelsList,
        interestsList: phpVars.interestsList,
        filter: {
          elevels:
            slugToObj(getUrlParameter('elevels'), phpVars.elevelsList),
          interests:
            slugToObj(getUrlParameter('interests'), phpVars.interestsList),
        },
        listings: {},
      },
      methods: {
        getListings: function() {
          if (!$('body').hasClass('home')) {
            this.isLoading = true;

            let parameters = {
              'per_page': 99,
              'orderby': 'rand',
              '_embed': 1,
            };

            if (this.filter.elevels) {
              parameters['filter[elevels]'] = this.filter.elevels.slug;
            }

            if (this.filter.interests) {
              parameters['filter[interests]'] = this.filter.interests.slug;
            }

            let that = this;

            $.ajax({
              url: wpApiSettings.root +
                   wpApiSettings.versionString + 'listings',
              data: parameters,
            })
            .done(function(data, status, xhr) {
              that.listings = data;
            })
            .always(function() {
              that.isLoading = false;
            });
          } else {
            let elevel =
              (this.filter.elevels) ? this.filter.elevels.slug : '';
            let interest =
              (this.filter.interests) ? this.filter.interests.slug : '';
            window.location.href =
              '/programme-finder/?elevels=' + elevel + '&interests=' + interest;
          }
        },
        resetFilters: function() {
          this.filter.elevels = null;
          this.filter.interests = null;
          this.getListings();
        },
      },
      mounted: function() {
        if ($('body').hasClass('page-template-template-programme-finder')) {
          this.getListings();
        }
      },
    });
  }

  /* SLIDER */
  if ($('.articles-slider .slick').length) {
    $('.articles-slider .slick').slick({
      prevArrow:
        '<button type="button" class="slick-prev">' +
        '<span class="sr-only">Previous</span>' +
        '</button>',
      nextArrow:
        '<button type="button" class="slick-next">' +
        '<span class="sr-only">Next</span>' +
        '</button>',
      autoplay: false,
      centerMode: true,
      slidesToShow: 4,
      variableWidth: true,
    });
  }
  
  if ($('.hero .slick').length) {
    $('.hero .slick').slick({
      prevArrow:
        '<button type="button" class="slick-prev">' +
        '<span class="sr-only">Previous</span>' +
        '</button>',
      nextArrow:
        '<button type="button" class="slick-next">' +
        '<span class="sr-only">Next</span>' +
        '</button>',
      dots: true,
      autoplay: true,
      autoplaySpeed: 5000,
      adaptiveHeight: true
    });
  }
  
  jQuery(".gfield input[type='text'], .gfield textarea").filter(
    function(){ 
      return jQuery(this).val(); 
    }).parent().parent().addClass('is-active');
    
  jQuery(".cleanlogin-login-edit input[type='text'], .cleanlogin-login-edit textarea, .cleanlogin-custom-container input").filter(
    function(){ 
      return jQuery(this).val(); 
    }).parent().addClass('is-active');
    
  // GForm Online Application
  var recomm_list_count = jQuery("#field_2_66 .gfield_list tbody tr").length;
  if( recomm_list_count == 1 ){
    var target_list = jQuery("#field_2_66 .gfield_list tbody tr:first-child .add_list_item");
    gformAddListItem(target_list);
  }
  
  jQuery(".gf-review-page-container .gfield_list").each( function(key, value){ 
    var temp_table = value;
    jQuery(this).find('th').each( function(key, ths){
      var th_wording = jQuery(ths).html();
      jQuery(temp_table).find('td:nth-child('+(key+1)+')').attr('data-label', th_wording.replace("&amp;", "&"));
    });
  });
  jQuery(".form_sublabel_below").removeClass("form_sublabel_below").addClass("form_sublabel_above");
  
  if( jQuery(".on-this-page .menu li").length > 0 ){
    console.log( jQuery(".on-this-page .menu li").length );
    jQuery("div.breadcrumbs").css("padding-bottom", "2.5rem");
  }
});
